<template>
  <div>
    <v-card class="text-xs-center mt-4" hover>
      <div style="position: absolute; left: 13px; top: 13px">
        <v-badge overlap :value="contractor.complianceCount > 0">
          <span slot="badge">{{ contractor.complianceCount }}</span>
          <v-icon color="grey" class="ma-1" @click="goToCompliance()">{{ $store.state.global.pages.compliance.icon }}</v-icon>
        </v-badge>
      </div>
      <div style="position: absolute; right: 3px; top: 3px">
        <v-btn
          flat
          icon
          color="grey"
          @click="edit = true"
          v-if="userAuthClass || allowInductionEntry"
        >
          <v-icon>edit</v-icon>
        </v-btn>
        <v-menu v-model="chooseChildPage" bottom offset-y>
          <v-btn flat icon color="grey" slot="activator">
            <v-icon>subdirectory_arrow_right</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile ripple router :to="{ name: 'vehicle', query: {fid: contractor.id}}">
              <v-list-tile-action>
                <v-icon :color="$store.state.global.pages.vehicle.color">{{ $store.state.global.pages.vehicle.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Show Vehicles</v-list-tile-title>
            </v-list-tile>
            <v-list-tile ripple router :to="{ name: 'driver', query: {fid: contractor.id}}">
              <v-list-tile-action>
                <v-icon :color="$store.state.global.pages.driver.color">{{ $store.state.global.pages.driver.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Show Drivers</v-list-tile-title>
            </v-list-tile>
            <v-list-tile ripple @click="goToCompliance()">
              <v-list-tile-action>
                <v-icon :color="$store.state.global.pages.compliance.color">{{ $store.state.global.pages.compliance.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>Show Compliance</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <div class>
        <v-avatar :color="color" size="66" class="overlap-avatar">
          <span class="white--text headline">{{letter.toUpperCase()}}</span>
        </v-avatar>
      </div>

      <v-card-text @click="chooseChildPage = true">
        <div class="pb-3">
          <h5 class="subheading font-weight-regular text-capitalize">{{contractor.name}}</h5>
          <div class="grey--text text-capitalize">
            <span class="clickable">ABN: {{contractor.abn}}</span>
          </div>
        </div>
        <div class="pb-4">
          <h5
            class="subheading font-weight-regular grey--text text--darken-1"
          >{{contractor.contactEmail}}</h5>
        </div>
        <div class="pb-4">
          <span
            class="font-weight-regular grey--text text--darken-1"
            v-if="!!contractor.driverCount"
          >Drivers: {{contractor.driverCount}}</span>
          <span v-if="!!contractor.driverCount && contractor.vehicleCount"> / </span>
          <span
            class="font-weight-regular grey--text text--darken-1"
            v-if="!!contractor.vehicleCount"
          >Vehicles: {{contractor.vehicleCount}}</span>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-btn
          flat
          icon
          color="grey"
          :href="'tel:'+contractor.contactPhone"
          v-if="!!contractor.contactPhone"
        >
          <v-icon>phone</v-icon>
        </v-btn>
        <v-btn
          flat
          icon
          color="grey"
          :href="'mailto:'+contractor.contactEmail"
          v-if="!!contractor.contactEmail"
        >
          <v-icon>mail</v-icon>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn flat icon color="red lighten-3" @click="deleteDialog = true" v-if="userAuthClass">
          <v-icon>delete</v-icon>
        </v-btn>
      </v-card-actions>
      <slot name="parentActions"></slot>
      <div class="card-divider grey lighten-2" style="margin-top: 0px;"></div>

      <div class="card-footer text-xs-left">
        <time-ago class="grey--text" :subject="contractor" :time="contractor.updatedAt" needsParse updated>
          <v-icon small color="grey" slot="icon" class="mr-2">access_time</v-icon>
        </time-ago>

      </div>
      <div style="width: 100%; height: 2px;" :class="color"></div>
    </v-card>

    <!--EDIT DIALOG -->
    <v-dialog
      lazy
      v-model="edit"
      max-width="700px"
      @keydown.esc="edit = false"
      v-if="userAuthClass || allowInductionEntry"
    >
      <edit-contractor :contractor="contractor" @close="edit = false"></edit-contractor>
    </v-dialog>

    <!-- DETAIL DIALOG -->
    <!-- <v-dialog v-model="detailDialog" fullscreen hide-overlay transition="scale-transition">
            <contractor-detail @close="detailDialog = false" :contractor = "contractor" :color="color"></contractor-detail>
    </v-dialog>-->

    <!-- DELETE CONFIRMATION DIALOG -->
    <v-dialog
      lazy
      v-model="deleteDialog"
      max-width="400px"
      @keydown.esc="deleteDialog = false"
      v-if="userAuthClass"
    >
      <v-card>
        <v-card-title class="headline">
          <span>
            Really delete?
            <span class="grey--text subheading">- {{contractor.name}}</span>
          </span>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" flat @click="deleteContractor(); deleteDialog = false">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import Store from '@/store/computed/storeHelpers'
import ContractorService from '@/services/requests/contractorService'
import getColorFromChar from '@/services/helpers/getColorFromChar'
import EditContractor from '@/components/contractors/editContractor'
import DisplaySnack from '@/services/mixins/displaySnack'
// import ContractorDetail from '@/components/contractors/contractorDetail'
export default {
  components: {
    // ContractorDetail,
    EditContractor
  },
  data() {
    return {
      edit: false,
      chooseChildPage: false,
      deleteDialog: false,
      detailDialog: false
    }
  },
  methods: {
    deleteContractor() {
      var contractor = this.contractor
      ContractorService.deleteContractor(contractor.id)
        .then(result => {
          //console.log(result.data);
          this.$store.commit('contractors/deleteFromArrayStateByValue', {
            prop: 'contractors',
            value: contractor
          })
          this.snack({ text: 'Contractor was deleted!', color: 'yellow' })
        })
        .catch(err => {
          //console.log("An error occured");
          this.snackError()
        })
    },
    goToCompliance() {
      this.model = 'contractor'
      this.subjectId = this.contractor.id
      this.contractorId = this.contractor.id
      this.vehicleId = null
      this.driverId = null
      this.$router.push({
        name: 'compliance'
      })
    }
  },
  props: {
    contractor: Object,
    index: Number
  },
  computed: {
    color() {
      return getColorFromChar(this.contractor.name.charCodeAt(0))
      //return this.$store.state.global.pages.contractor.color;
    },
    letter() {
      return this.contractor.name.charAt(0)
    },
    model: Store.getSet({ store: 'compliance', prop: 'model' }),
    subjectId: Store.getSet({ store: 'compliance', prop: 'subjectId' }),
    contractorId: Store.getSet({ store: 'compliance', prop: 'contractorId' }),
    vehicleId: Store.getSet({ store: 'compliance', prop: 'vehicleId' }),
    driverId: Store.getSet({ store: 'compliance', prop: 'driverId' })
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}
.overlap-avatar {
  margin-top: -35px;
  border: 6px solid #eee;
  border-color: #eee !important;
}
</style>
